import { useState, useEffect } from "react";
import styles from './CompareBox.module.scss';

export default function CompareBox({
                                       product,
                                       labels,
                                       isSelected: initiallySelected = false,
                                   }) {
    const [isSelected, setIsSelected] = useState(initiallySelected);

    useEffect(() => {
        const updateSelection = () => {
            const list = window.comparisonList || [];

            // If this product is NOT in the comparison list → uncheck it
            const isInList = list.some((item) => item.productId === product.productId);
            console.log('isInList',isInList);
            if (!isInList && isSelected) {
                setIsSelected(false);
            }

            // If it's in the list but not selected yet → check it
            else if (isInList && !isSelected) {
                setIsSelected(true);
            }
        };

        updateSelection();

        // listen for global list updates
        window.addEventListener("editCompareList", updateSelection);
        return () => window.removeEventListener("editCompareList", updateSelection);
    }, [isSelected, product.productId]);

    const handleChange = () => {
        const newChecked = !isSelected;
        setIsSelected(newChecked);

        const productId = product.productId;
        const skuId = product.characteristics?.[0].skuId;
        const productTypeVal = product.productType;
        const prodName = product.characteristics?.[0].name;
        const isAlreadySelected = !newChecked;

        const newItem = { productId, skuId, productTypeVal, prodName, isAlreadySelected };

        const compareEvent = new CustomEvent("editCompareList", {
            detail: {
                item: newItem,
                editCompareList: true,
            },
        });

        window.dispatchEvent(compareEvent);
    };

    return (
        <div className={`compareBox ${styles.container}`}>
            <label className={`custom-container ${styles.checkboxContainer}`}>
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleChange}
                />
                <span className={`custom-comparebox-checkmark ${styles.checkbox}`}></span>
                <span className={`custom-comparebox-label ${styles.label}`}>{labels["compare"]}</span>
            </label>
        </div>
    );
}